// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b1704520","513":"16478682","787":"47855dff"}[chunkId] + ".chunk.js";
};